"use strict";

exports.__esModule = true;
var _TextValue = require("./TextValue");
Object.keys(_TextValue).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TextValue[key]) return;
  exports[key] = _TextValue[key];
});